import { FileImageOutlined, FileOutlined, FilePdfOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';

const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg']);

/** Extension → advisor-facing file-row icon. One source of truth for
 *  `AdditionalDocumentsStep`, `PdfGenerationStep`, and
 *  `ApplicationReviewStep` so extending the icon set (e.g. `.heic` from
 *  phone photos, `.tif`, `.docx`) is a one-line change and every surface
 *  updates together. `size` defaults to 18 (the existing per-row treatment
 *  in AdditionalDocuments + ApplicationReview); PdfGenerationStep passes
 *  22 for its larger row layout. */
export function fileIcon(fileName: string, size = 18): ReactNode {
  const dot = fileName.lastIndexOf('.');
  const ext = dot >= 0 ? fileName.slice(dot + 1).toLowerCase() : '';
  if (ext === 'pdf') return <FilePdfOutlined style={{ color: '#dc2626', fontSize: size }} />;
  if (IMAGE_EXTS.has(ext))
    return <FileImageOutlined style={{ color: '#0179C1', fontSize: size }} />;
  return <FileOutlined style={{ color: '#475569', fontSize: size }} />;
}
